import { DEVELOPMENT, PRODUCTION } from './constants';
import { getResourceTypeFromLocalStorage } from './getResourceTypeFromLocalStorage';

export const PRODUCTION_ENVIRONMENT = 'production';

export type ResourceType = typeof DEVELOPMENT | typeof PRODUCTION;

export const getResourceType = (): ResourceType => {
  const localStorageResourceType = getResourceTypeFromLocalStorage();

  if (localStorageResourceType) {
    return localStorageResourceType;
  }

  if (process.env.NODE_ENV === PRODUCTION_ENVIRONMENT) {
    return PRODUCTION;
  }

  return DEVELOPMENT;
};
